import { EnumerateDates } from '../../utils/dateUtils';
import { SeriesInRange } from '../../utils/arrayUtils';
import { SumLastDaysFromAnchor, SumOffsetWindow } from './SumWindow';

/**
 * Para colunas com JANELA FIXA (sales3/7/30, week1..4, month1..3):
 * devolve a SOMA do range fixo daquela coluna a partir do anchor.
 *
 * Se o filtro ativo (ctx.periodStart/End) é MENOR que a janela fixa,
 * a coluna usa o filtro (proporcional) — explicitado via tooltip no header.
 *
 * Convenção (anchor = "hoje" do backend):
 *   sales3   → últimos 3d
 *   sales5   → últimos 5d
 *   sales7   → últimos 7d
 *   sales30  → últimos 30d
 *   week1    → últimos 7d (= sales7)
 *   week2    → 8..14d atrás
 *   week3    → 15..21d atrás
 *   week4    → 22..28d atrás
 *   month1   → últimos 30d (= sales30)
 *   month2   → 31..60d atrás
 *   month3   → 61..90d atrás
 */
const COL_WINDOWS = {
    sales3: { days: 3, offset: 0 },
    sales5: { days: 5, offset: 0 },
    sales7: { days: 7, offset: 0 },
    sales30: { days: 30, offset: 0 },
    sales60: { days: 60, offset: 0 },
    sales90: { days: 90, offset: 0 },
    sales180: { days: 180, offset: 0 },
    sales365: { days: 365, offset: 0 },
    week1: { days: 7, offset: 0 },
    week2: { days: 7, offset: 7 },
    week3: { days: 7, offset: 14 },
    week4: { days: 7, offset: 21 },
    month1: { days: 30, offset: 0 },
    month2: { days: 30, offset: 30 },
    month3: { days: 30, offset: 60 },
};

export function ColumnWindowDef(col) {
    return COL_WINDOWS[col] || null;
}

export function SumColumnWindow(dailyByDate, ctx, col) {
    const def = ColumnWindowDef(col);
    if (!def || !ctx?.anchorDateIso) return 0;
    if (def.offset === 0) {
        return SumLastDaysFromAnchor(dailyByDate, ctx.anchorDateIso, def.days);
    }
    return SumOffsetWindow(dailyByDate, ctx.anchorDateIso, def.days, def.offset);
}

/** Série de qtds por dia (ASC) pra sparkline. Datas faltantes = 0. */
export function SeriesColumnWindow(dailyByDate, ctx, col) {
    const def = ColumnWindowDef(col);
    if (!def || !ctx?.anchorDateIso) return [];
    const anchorDate = new Date(`${ctx.anchorDateIso}T00:00:00Z`);
    const endDate = new Date(anchorDate);
    endDate.setUTCDate(endDate.getUTCDate() - def.offset);
    const startDate = new Date(endDate);
    startDate.setUTCDate(startDate.getUTCDate() - (def.days - 1));
    const dates = EnumerateDates(startDate, endDate);
    return SeriesInRange(dailyByDate, startDate, endDate, dates);
}
